import { Injectable, signal, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class SidebarStateService {
  private platformId = inject(PLATFORM_ID);

  readonly isSidebarLocked = signal<boolean>(false);
  readonly searchQuery = signal<string>('');

  // ================= Normal Functions =================

  constructor() {
    this.initializeState();
  }

  /**
   * Initializes the sidebar lock state from localStorage.
   * Defaults to locked on first visit.
   */
  private initializeState(): void {
    if (isPlatformBrowser(this.platformId)) {
      const storedLocked = localStorage.getItem('sidebar_locked');
      if (storedLocked === null) {
        localStorage.setItem('sidebar_locked', 'true');
        this.isSidebarLocked.set(true);
      } else {
        this.isSidebarLocked.set(storedLocked === 'true');
      }
    }
  }

  /**
   * Toggles the sidebar lock state and saves the value to localStorage.
   */
  toggleSidebarLock(): void {
    const nextVal = !this.isSidebarLocked();
    this.isSidebarLocked.set(nextVal);
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('sidebar_locked', String(nextVal));
    }
  }

  // ================= API Functions =================
}
